import {createFileRoute, notFound, useLoaderData} from '@tanstack/react-router'
import {apiRetrieveImproved} from "@/api.ts";
import BlogPage from "@/landing/BlogPage.tsx";
import {Post} from "@/types";

export const Route = createFileRoute('/blog/$post_slug')({
    loader: async ({params}) => {
        const post = await apiRetrieveImproved('posts-find', {post_slug: params.post_slug}) as Post;
        // Unknown/retired slugs come back as an empty object — return a real 404 instead of a
        // soft-404 (HTTP 200 + client redirect), so Google drops dead blog URLs cleanly.
        if (!post || !(post as any).uid) {
            throw notFound();
        }
        return {post};
    },
    component: RouteComponent,
})

function RouteComponent() {
    const {post} = useLoaderData({from: '/blog/$post_slug'});
    return <BlogPage initialPost={post} />
}
